import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import './rotasModule.css'

export default class CoordRotas extends React.Component {
    constructor(props) {
        super(props)
        this.state = { list: [], aprovadas: [], reprovadas: [], loaded: false }
    }

    componentDidMount() {
        axios('/api/rota/2')
            .then((resp) => this.setState({ list: resp.data, loaded: true }))
            .catch((error) => alert(error.response?.data || 'Erro ao carregar rotas.'))
    }

    updateField(id, action) {
        this.setState((prevState) => {
            const aprovadas = prevState.aprovadas.filter((item) => item !== id)
            const reprovadas = prevState.reprovadas.filter((item) => item !== id)
            if (action === 'aprova') aprovadas.push(id)
            if (action === 'reprova') reprovadas.push(id)
            return { aprovadas, reprovadas }
        })
    }

    aprova = async () => {
        try {
            await axios.post('/api/rota/aprova2', { aprovadas: this.state.aprovadas, reprovadas: this.state.reprovadas })
            alert('Rotas atualizadas.')
            window.location = '/coordRotas'
        } catch (error) {
            alert(error.response?.data || 'Erro ao salvar decisão.')
        }
    }

    render() {
        return (
            <div className="container rota-page">
                <div className="rota-hero">
                    <p className="rota-eyebrow mb-1">Coordenação</p>
                    <h1 className="rota-title mb-2">Fila de decisão de rotas</h1>
                    <p className="rota-subtitle mb-0">Avalie solicitações abertas e acesse a visualização detalhada antes de aprovar ou reprovar.</p>
                </div>
                <div className="rota-surface">
                    <div className="table-responsive">
                        <table className="table table-borderless mb-0">
                            <thead>
                                <tr>
                                    <th>Decisão</th>
                                    <th>Fiscal</th>
                                    <th>Estado</th>
                                    <th>Itens</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loaded && this.state.list.map((rota) => {
                                    const normalized = rota.normalized || { analytics: {} }
                                    return (
                                        <tr key={rota._id}>
                                            <td>
                                                <div className="rota-radio-group">
                                                    <div className={`rota-radio-option ${this.state.aprovadas.includes(rota._id) ? 'active realizada' : ''}`} onClick={() => this.updateField(rota._id, 'aprova')}>
                                                        <strong>Aprovar</strong>
                                                    </div>
                                                    <div className={`rota-radio-option ${this.state.reprovadas.includes(rota._id) ? 'active nao-realizada' : ''}`} onClick={() => this.updateField(rota._id, 'reprova')}>
                                                        <strong>Reprovar</strong>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{rota.fiscal}</td>
                                            <td>{rota.estado}</td>
                                            <td>{normalized.analytics?.totalItens || 0}</td>
                                            <td>
                                                <Link to={`/rotasView/${rota._id}`} target="_blank">
                                                    <button className="btn rota-secondary-button">Abrir</button>
                                                </Link>
                                            </td>
                                        </tr>
                                    )
                                })}
                                {this.state.loaded && this.state.list.length === 0 && <tr><td colSpan="5" className="text-center rota-muted">Não há rotas abertas.</td></tr>}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex justify-content-end mt-4">
                        <button className="btn rota-primary-button" onClick={this.aprova}>Salvar decisões</button>
                    </div>
                </div>
            </div>
        )
    }
}
